module.exports = __webpack_public_path__ + "media/images/lp/lp15-84b794d9cd380efbe74681a1c3c94b6c.webp";